import { forwardRef } from "react";
import { SystemFieldType, SystemPageType } from "../../../../Model/SystemModels";
import { CardField } from "../../../Common/Template/Card/CardField";
import { CardGroup } from "../../../Common/Template/Card/CardGroup";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";

export const AdminBookingStaffMemberCard = forwardRef<PageContainerBase, React.PropsWithChildren<{}>>((props, ref) => {
    return (
        <PageContainer pageType={SystemPageType.Card} title={"Servizio Booking"} endpoint="/odata/booking/staff/member" ref={ref}>
            <CardGroup name="general" label="Generale" isOpen={true}>
                <CardField name="calendarId" type={SystemFieldType.String} label="Calendar Id" readonly />
                <CardField name="id" type={SystemFieldType.String} label="Id" readonly />
                <CardField name="displayName" type={SystemFieldType.String} label="Name" readonly />
                <CardField name="emailAddress" type={SystemFieldType.String} label="Email" readonly />
                <CardField name="role" type={SystemFieldType.String} label="Role" readonly />
                <CardField name="userId" type={SystemFieldType.Option} label="User" hasTableRelation tableRelationEndpoint="odata/user" tableRelationKey="id" tableRelationField="displayName" tableRelationFilter="?$filter=crmSystemUserId gt ''" />
            </CardGroup>
        </PageContainer>
    );
});